export const DEFAULT_CATEGORY = { id: "anyCategory", name: "Any Category" };

export const DIFFICULTIES = [
  { id: "anyDifficulty", name: "Any Difficulty" },
  { id: "easy", name: "Easy" },
  { id: "medium", name: "Medium" },
  { id: "hard", name: "Hard" },
];

export const TIMERS = [
  { id: "0", name: "No Timer" },
  { id: "10", name: "10" },
  { id: "15", name: "15" },
  { id: "20", name: "20" },
  { id: "30", name: "30" },
];